var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilhotte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4201_2519)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5341 39.2086C63.7138 43.3074 63.7685 48.1422 62.181 51.2278C59.9158 55.6317 54.9572 58.3452 50.9318 58.3452C46.6524 58.3452 41.9104 55.4251 39.6833 50.5406C38.347 47.609 36.8423 40.116 36.4703 36.3303C35.4039 25.4869 40.3129 19.3495 51.1023 19.12C63.0568 18.8653 66.6 28.8768 64.5341 39.2086Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1274 35.5944C35.4443 34.6755 33.913 34.8288 34.2196 36.8184C34.5254 38.8081 34.9845 44.1646 36.0559 45.0821C37.1274 46.001 38.1981 46.3069 38.8112 45.2354C39.4236 44.1647 37.1274 35.5944 37.1274 35.5944Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9092 34.7548C65.593 33.8359 67.1243 33.9892 66.8184 35.9788C66.5119 37.9685 66.0535 43.325 64.9813 44.2425C63.9092 45.1614 62.8391 45.4672 62.2268 44.3958C61.6137 43.325 63.9092 34.7548 63.9092 34.7548Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3936 49.8003C41.8534 54.0854 41.7002 60.5141 40.782 63.7278C40.9345 63.8803 44.7167 71.6641 51.9542 71.2266C58.7493 70.8157 61.2908 63.2687 61.2908 63.2687C61.2908 63.2687 59.738 55.2209 60.831 50.2601C61.7938 45.8843 41.3936 49.8003 41.3936 49.8003Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.201 73.5685C86.241 70.8104 81.8041 69.251 81.8041 69.251L63.6346 61.6954L60.4274 56.8612L51.1599 62.52L41.8334 56.8015L38.9284 61.6357L20.9388 68.471C20.9388 68.471 18.1209 69.5504 16.322 71.5897C15.5628 72.4503 12.5909 82.6641 11.8022 100H90.2772C89.4892 82.6633 87.578 74.6529 87.201 73.5685Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8671 21.8481C41.3879 17.8904 43.6963 16.2116 51.4016 17.5003C56.0494 18.2775 61.3556 20.3787 61.8356 17.7407C62.0176 16.739 64.3541 22.1776 61.3563 23.8571C59.6689 24.802 43.6064 22.8972 43.6064 22.8972L41.8671 21.8481Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4069 21.4576C41.8075 20.7381 39.8883 20.2588 38.809 21.3382C37.7296 22.4176 34.2813 26.7048 35.9609 35.3399C37.6396 43.9749 39.8883 36.4487 39.8883 36.4487L42.2874 21.9376L42.4069 21.4576Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9957 21.8782C61.7153 21.6084 63.0343 21.1587 63.8741 22.6576C64.8887 24.4695 66.5128 29.4339 64.9837 35.6698C63.1854 43.0016 62.5551 35.2201 62.5551 35.2201L59.0471 23.4369L60.9957 21.8782Z",
    fill: "#939393"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 98,
    height: 98,
    rx: 49,
    stroke: "#EDEDED",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4201_2519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilhotte);
export default __webpack_public_path__ + "static/media/silhotte.7b6486637803278f769274749be89d81.svg";
export { ForwardRef as ReactComponent };